import { HttpClient } from '@angular/common/http';
import { inject, NgModule } from '@angular/core';
import {
  NgIconsModule,
  provideNgIconLoader,
  withCaching,
} from '@ng-icons/core';
import { IconsService } from './services/icons/icons-service.service';

@NgModule({
  declarations: [],
  imports: [
    NgIconsModule.withIcons({})
  ],
  exports: [NgIconsModule],
  providers: [
    provideNgIconLoader((name) => {
      const service = inject(IconsService);

      return service.getIcon(name, { responseType: 'text' });
    }),
  ],
})
export class IconsModule { }
